import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { useEffect } from "react";

export default function Disclaimer() {

    useEffect(() => {
    }, []);

    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
                    Disclaimer
                </h1>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark rounded-[28px] border border-borderLight dark:border-borderDark p-10 shadow-lg">

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        The information provided on{" "}
                        <Link to="/" className="text-primary underline">
                            Online-Clipboard.in
                        </Link>{" "}
                        is for general informational and utility purposes only.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        No Guarantees
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        While we strive to keep the service accurate and reliable, we make no guarantees regarding the completeness, accuracy, or reliability of the service.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Use at Your Own Risk
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Any action you take using this website is strictly at your own risk. We are not responsible for any losses or damages.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        External Links
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Our website may contain links to external sites. We do not control or take responsibility for the content of these external websites.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Service Availability
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We do not guarantee uninterrupted access. The service may be unavailable due to maintenance or technical issues.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Consent
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8">
                        By using this website, you agree to this disclaimer and its terms.
                    </p>

                </div>

                <Footer />

            </div>

        </section>
    );
}